import { render, staticRenderFns } from "./ProviderContactAddEdit.vue?vue&type=template&id=1ec718c1"
import script from "./ProviderContactAddEdit.vue?vue&type=script&lang=js"
export * from "./ProviderContactAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports